import { render } from "./QInputField.vue?vue&type=template&id=3b4675a2"
import script from "./QInputField.vue?vue&type=script&lang=ts"
export * from "./QInputField.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
